import { LOCAL__grid2d_chunk_update_without_cells } from '@/state/grid2d/grid2d_chunk/LOCAL__grid2d_chunk_update_without_cells';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { try_update_from_generation_on_user_task_grid2d_chunk_without_cells } from '../../_methods/user_task/try_update_from_generation_on_user_task_grid2d_chunk_without_cells';

export function HANDLER_CLIENT__grid2d_chunk_update_without_cells(items: any) {
  assert_array_instanceof(items, DTO__grid2d_chunk);

  store.dispatch(LOCAL__grid2d_chunk_update_without_cells(items));

  items.forEach(try_update_from_generation_on_user_task_grid2d_chunk_without_cells);
}
